<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="'/visits/tables/cities'"
      [chartColumn]="'City'"
    >
    </app-api-table>
  }
</app-tab-layout>
